var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSparkle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#sparkle_svg__a)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M10 4.085C10 7.352 12.06 10 14.6 10c-2.54 0-4.6 2.648-4.6 5.915C10 12.648 7.94 10 5.4 10 7.94 10 10 7.352 10 4.085"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "sparkle_svg__a",
  x1: 10,
  x2: 10,
  y1: 4.085,
  y2: 15.915,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#88F8EF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#595BEE"
})))));
export default SvgSparkle;